module.exports = __webpack_public_path__ + "static/media/Base feature icon-3.66e1114f.svg";